export const isEmpty = value => {
  return value === null || value === undefined || value.length === 0;
};

export const isNull = value => {
  try {
    return value === null;
  } catch (e) {
    return false;
  }
};

export const uuid4 = () => {
  let d = new Date().getTime();
  // eslint-disable-next-line func-names
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    /* eslint no-bitwise: ["error", { "allow": ["|", "&"] }] */
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};
